import React from 'react'
import Link from 'gatsby-link'

import './style/side-nav.css'

export default (props) => (
  <div className='side-nav'>
    {props.components.map((title, i) => {
      let path = title === props.base ? `/${title}` : `/${props.base}/${title}`
      return (
        <span className='side-nav-link-wrap' key={i}>
          <span className={title === props.current ? 'side-nav-link-title-selected' : 'side-nav-link-title'}>
            <Link className='side-nav-link' to={path}>
              {title} <i className='fa fa-caret-right' aria-hidden='true' />
            </Link>
          </span>
        </span>
      )
    })}
  </div>
)



// WEBPACK FOOTER //
// ./src/layouts/side-nav.js